<template lang='pug'>
  bf-flex.bf-header.component.centered
    slot
      bf-flex.container
        .white.circle.left.shape
        .band.left.shape
        .circle.left.shape
        h6.title.ellipsis {{ $t(title) }}
        .circle.right.shape
        .band.right.shape
        .white.circle.right.shape
</template>

<script>
  export default {
    name: 'bf-header.component',

    props: {
      title: String
    }
  }
</script>

<style scoped lang='stylus'>
  .bf-header
    background white
    margin-top 20px
    .container
      // background blue

  .title
    background var(--clr-orange)
    padding 8px 48px
    @media(min-width: 1080px)
      padding 6px 48px
  .shape
    position relative
    background var(--bg-nav)
    height 32px
    width 32px
    z-index 2
  .circle
    border-radius 50%
    &.left
      left 16px
    &.right
      right 16px
  .band
    width 24px
    z-index 1
    bottom 14px
    &.left
      transform rotate(-45deg)
      left 28px
    &.right
      transform rotate(45deg)
      right 28px
  .white.circle
    background white
    &.left
      border-top-right-radius: 88%
      left 40px
    &.right
      border-top-left-radius: 88%
      right 40px
</style>
